import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from '../../../../services/ui-services';

@Component({
  selector: 'app-card-admin',
  templateUrl: './card-admin.component.html',
  styleUrls: ['./card-admin.component.scss'],
})
export class CardAdminComponent implements OnInit {
  @Input() opts:any;

  constructor(
    private uiSv: UiServices,
    private httpSv: HttpService,
    private translateSv: TranslateService
  ) {}

  ngOnInit() {}

  async create(){
    await this.uiSv.showModal(this.opts.component, { type: this.opts.type }, 'modalAdmin')
  }

  async edit(){
    const { data, role } = await this.uiSv.showModal(this.opts.editComponent, { type: this.opts.type }, 'modalAdmin');
    if(!data) return;
    if(role === 'edit'){
      await this.uiSv.showModal(this.opts.component, { edit: data, type: this.opts.type }, 'modalAdmin');
    }else{
      const tr = this.translateSv.instant('DESEAS_ELIMINAR');
      const { role } = await this.uiSv.presentAlert(`${tr} ${data.name}?`);
      if(role === 'accept'){
        try{
          const body = { id: data.id };
          const lengthType = this.opts.type.length;
          const fixedType = this.opts.type.slice(0, lengthType - 1);
          await this.httpSv.deleteItem(body, fixedType);
          const translate = this.translateSv.instant('ELIMINADO_CON_EXITO');
          this.uiSv.showToast(`${data.name}. ${translate}`)
        }catch(err){
          const translate = this.translateSv.instant('HA_OCURRIDO_UN_ERROR');
          this.uiSv.showToast(translate);
        }
      };
    }
  }
}
